<template>
  <div
    class="common-home-content"
    :class="is_app ? '' : 'common-home-content-pt'"
    v-show="show"
  >
    <div class="home-header" v-if="!is_app">
      <button class="page-back" @click="pageback"><span></span></button>
      <span class="title">{{ title }}</span>
      <button class="header-right-btn" v-if="address_id" @click="handelDelete">
        删除
      </button>
    </div>
    <div class="edit-content space_pl space_pr">
      <van-field
        class="edit-text"
        v-model="form.nickname"
        placeholder="收货人姓名"
      />
      <van-field
        class="edit-text"
        v-model="form.phone"
        placeholder="收货人手机号码"
      />
      <van-field
        class="edit-area edit-area1"
        rows="1"
        autosize
        type="textarea"
        @click="showPopup"
        v-model="form.area_value"
        placeholder="所在地区"
        readonly
      />
      <img class="imgStep" src="../../assets/images/address/gengd.png" alt="">
      <van-field
        v-model="form.address"
        rows="3"
        autosize
        type="textarea"
        class="edit-textarea"
        placeholder="详细地址：如街道、小区、门牌号、单元室等"
      />
      <div class="tags-name-content">
        <label>地址标签</label>
        <ul class="tags-ul clearfix">
          <li
            class="fl"
            :class="form.tag_name == tag ? 'actived' : ''"
            v-for="(tag, index) in tags"
            :key="index"
            @click="handleSelectTag(tag)"
          >
            {{ tag }}
          </li>
          <li class="fl" @click="handleAddTag">
            <span class="add-icon"></span>
          </li>
        </ul>
      </div>
      <van-cell-group>
        <van-switch-cell
          class="edit-switch"
          active-color="#ac4b38"
          inactive-color="#cccccc"
          v-model="is_default"
          title="设置默认地址"
        />
      </van-cell-group>
    </div>
    <div class="fixed-btns">
      <button @click="hadleSave">保 存</button>
    </div>
    <van-popup
      v-model="area_popup_show"
      class="area-popup-content"
      position="bottom"
      :class="[
        showArea.length == 1 ? 'area-popup-pt' : '',
        showArea.length == 2 ? 'area-popup-pt2' : '',
      ]"
      :safe-area-inset-bottom="true"
    >
      <h3 class="area-popup-title">
        请选择<span class="close" @click="handleCloseAreaWindow"></span>
      </h3>
      <div class="area-steps" v-if="showArea.length > 0">
        <p class="step-p" v-for="(child, index) in showArea" :key="index">
          <span class="first-step" v-if="index == 0"></span>{{ child.name }}
        </p>
        <p class="step-p actived" v-if="showArea.length == 1">
          <span class="last-step"></span>请选择城市
        </p>
        <p class="step-p actived" v-if="showArea.length == 2">
          <span class="last-step"></span>请选择县
        </p>
        <div class="line"><span></span></div>
      </div>
      <div class="select-area-content">
        <div v-if="showArea.length == 0">
          <p class="select-area-title pt15">热门城市</p>
          <ul class="hot-citys-ul clearfix">
            <li
              class="hot-citys-li fl"
              v-for="(child, index) in hotCitys"
              :key="index"
            >
              <div
                class="hot-citys-name"
                @click="handleSelectArea(child, true)"
              >
                {{ child[1]["text"] }}
              </div>
            </li>
          </ul>
        </div>
        <p class="select-area-title pt16 mb10" v-if="showArea.length == 0">
          选择省份/地区
        </p>
        <p class="select-area-title pt16 mb10" v-if="showArea.length == 1">
          选择城市
        </p>
        <p class="select-area-title pt16 mb10" v-if="showArea.length == 2">
          选择区县
        </p>
        <div v-for="(value, key, index) in areaObj" :key="index">
          <ul class="area-initials-ul">
            <li
              class="area-initials-li area-initials-li-pr"
              v-for="(child, child_index) in value"
              :key="child_index"
              @click="handleSelectArea(child, false)"
            >
              <label class="area-initials-label" v-if="child_index == 0">{{
                key
              }}</label>
              {{ child["name"] }}
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
    <van-popup
      class="tag-popup-window"
      v-model="tag_popup_show"
      :close-on-click-overlay="false"
    >
      <div class="popup-window">
        <p class="title">添加标签</p>
        <van-field
          class="tag-text"
          maxlength="5"
          v-model="edit_tag_vlue"
          placeholder="例如：闺蜜家（不超过5个字）"
        />
        <div class="btns clearfix">
          <button class="fl left" @click="handleClosePopup">取消</button>
          <button class="fr right" @click="handleConfirmSave">保存</button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="delete_popup_show" :close-on-click-overlay="false">
      <div class="delete-popup-window">
        <p class="title">是否删除该地址</p>
        <div class="btns clearfix">
          <button class="fl left" @click="handleCloseDeletePopup">取消</button>
          <button class="fr right" @click="handleConfirmDelete">删除</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
import $ from 'jquery'
import { deviceType } from '../../util/deviceType'
import http from '../../util/gaeaApiConfig'
import http2 from '../../util/hermerApiConfig'
import vPinyin from '../../util/vue-py'
export default {
  data () {
    return {
      show: false,
      area_popup_show: false,
      tag_popup_show: false,
      delete_popup_show: false,
      tags: ['家', '公司', '学校'],
      edit_tag_vlue: '',
      tag_key: '',
      token: '',
      address_id: false,
      user_id: 1,
      hotCitys: [
        [
          { id: 1, name: '北京市', code: '110000' },
          { id: 35, name: '市辖区', text: '北京市', code: '110100' }
        ],
        [
          { id: 10, name: '江苏省', code: '320000' },
          { id: 108, name: '南京市', text: '南京市', code: '320100' }
        ],
        [
          { id: 22, name: '重庆市', code: '500000' },
          { id: 270, name: '市辖区', text: '重庆市', code: '500100' }
        ]
      ],
      form: {},
      results: [],
      area: [],
      areaObj: {},
      areaList: [],
      selectArea: [],
      showArea: [],
      platform_type:1,
      is_default: false,
      is_app: deviceType.isApp,
      title: '新建收货地址'
    }
  },
  metaInfo () {
    return { title: this.title }
  },
  created () {
    let bridge = window.WebViewJavascriptBridge
    this.isApp = this.$appUtils.isApp()

    if (this.isApp == 'IOS') {
      bridge.callHandler('getUserInfo', '', (response) => {
        this.user_id = response.user_id
        this.platform_type = response.platform_type
        this.token = response.token
      })
      if (localStorage.getItem('user_id')) {
        this.user_id = localStorage.getItem('user_id')
        bridge.callHandler('showTrBtn', { name: '删除' }, (response) => {})
      } else {
        bridge.callHandler('showTrBtn', { name: '' }, (response) => {})
      }

      bridge.registerHandler('appTrBtnClick', '', () => {
        this.handelDelete()
      })
    } else if (this.isApp == 'android') {
      var user_info = this.$appUtils.appData()
      if (user_info) {
        this.user_id = user_info.user_id
        this.token = user_info.token
        this.platform_type = user_info.platform_type
      }
      if (localStorage.getItem('user_id')) {
        this.$appUtils.showAppTrBtn({ name: '删除' })
      } else {
        this.$appUtils.showAppTrBtn({})
      }
    } else {
      this.user_id = localStorage.getItem('user_id')
      this.token = localStorage.getItem('token')
      this.platform_type = '1'
    }
    window.appTrBtnClick = () => this.handelDelete()
    window.appBack = () => this.pageback()
    this.tag_key = 'local_tags_' + this.user_id
    if (localStorage.getItem(this.tag_key)) {
      this.tags = localStorage.getItem(this.tag_key).split(',')
    }
    if (this.$route.query.address_id) {
      this.title = '编辑地址'
      this.address_id = this.$route.query.address_id
      setTimeout(() => {
        this.getDate()
      }, 1000)
    } else {
      this.form = {
        nickname: '',
        phone: '',
        area: [],
        area_value: '',
        address: '',
        tag_name: ''
      }
      this.show = true
    }
  },
  methods: {
    getAreasValue (arr) {
      let str = ''
      if (arr) {
        arr = JSON.parse(arr)
        for (let i = 0; i < arr.length; i++) {
          if (i == 0) {
            str = arr[i]['name']
          } else {
            str = str + ' ' + arr[i]['name']
          }
        }
      }
      return str
    },
    getDate () {
      let that = this
      http
        .get('/users/' + that.user_id + '/address/' + that.address_id+'?platform_type=' +this.platform_type, {
          headers: {
            Authorization: that.token
          }
        })
        .then(function (res) {
          let data = res.data.data
          that.form = {
            nickname: data.nickname,
            phone: data.phone,
            area: JSON.parse(data.area),
            area_value: that.getAreasValue(data.area),
            address: data.address,
            tag_name: data.tag_name
          }
          if (data.is_default == 2) {
            that.is_default = true
          } else {
            that.is_default = false
          }
          that.show = true
        })
    },
    hadleSave () {
      let that = this
      if (!that.form.nickname) {
        that.$toast('收货人姓名不能为空！')
      } else if (!that.form.phone) {
        that.$toast('手机号码不能为空！')
      } else if (!that.$pubUtils.checkPhone(that.form.phone)) {
        that.$toast('手机号码格式错误，请重新输入！')
      } else if (!that.form.area_value) {
        that.$toast('所在地区不能为空！')
      } else if (!that.form.address) {
        that.$toast('详细地址不能为空！')
      } else {
        let params = {
          nickname: that.form.nickname,
          phone: that.form.phone,
          area: JSON.stringify(that.form.area),
          address: that.form.address,
          'postcode	': that.form.area[that.form.area.length - 1]['code']
        }
        if (that.form.tag_name) {
          params['tag_name'] = that.form.tag_name
        }
        if (that.is_default) {
          params['is_default'] = 2
        } else {
          params['is_default'] = 1
        }
        if (that.address_id) {
          http
            .put(
              '/users/' + that.user_id + '/addresses/' + that.address_id+'?platform_type=' +this.platform_type,
              params,
              { headers: { Authorization: that.token } }
            )
            .then(function (res) {
              if (res.data.status_code == 200) {
                that.pageback()
              }
            })
        } else {
          http
            .post('/users/' + that.user_id + '/addresses'+'?platform_type=' +this.platform_type, params, {
              headers: { Authorization: that.token }
            })
            .then(function (res) {
              if (res.data.status_code == 200) {
                that.pageback()
              }
            })
        }
      }
    },
    handleSelectTag (tag) {
      this.form.tag_name = tag
    },
    handleAddTag () {
      this.edit_tag_vlue = ''
      this.tag_popup_show = true
    },
    handleClosePopup () {
      this.tag_popup_show = false
    },
    handleConfirmSave () {
      if (this.edit_tag_vlue) {
        this.tags.push(this.edit_tag_vlue)
        localStorage.setItem(this.tag_key, this.tags)
      }
      this.tag_popup_show = false
    },
    handelDelete () {
      this.delete_popup_show = true
    },
    handleCloseDeletePopup () {
      this.delete_popup_show = false
    },
    handleConfirmDelete () {
      let that = this
      let params = {
        address_ids: that.address_id
      }
      http
        .delete(
          '/users/' + that.user_id + '/addresses'+'?platform_type=' +this.platform_type,
          { params: params },
          { headers: { Authorization: that.token } }
        )
        .then(function (res) {
          if (res.data.status_code == 200) {
            that.pageback()
          }
        })
    },
    getAreasFormat (arr) {
      let str = ''
      for (let i = 0; i < arr.length; i++) {
        if (i == 0) {
          str = arr[i]['name']
        } else {
          str = str + ' ' + arr[i]['name']
        }
      }
      this.form.area_value = str
      this.form.area = arr
    },
    getAreas (obj) {
      let that = this
      if (that.showArea.length >= 2) {
        that.getAreasFormat(that.area)
        that.showArea = []
        that.area_popup_show = false
      } else {
        let id = ''
        if (typeof obj === 'object') {
          id = obj['id']
        } else {
          id = obj
        }
        http2.get('/areas/' + id+'?platform_type=' +this.platform_type).then(function (res) {
          that.results = res.data.data
          that.results = _.map(that.results, function (item) {
            item['pinyin'] = vPinyin.codefans_net_CC2PY(item['name'])
            item['initials'] = vPinyin.initialTreatment(item['name'])
            return item
          })
          that.results = _.sortBy(that.results, 'initials')
          that.areaObj = {}
          for (let i = 0; i < that.results.length; i++) {
            if (that.areaObj[that.results[i]['initials']]) {
              that.areaObj[that.results[i]['initials']].push(that.results[i])
            } else {
              that.areaObj[that.results[i]['initials']] = []
              that.areaObj[that.results[i]['initials']].push(that.results[i])
            }
          }
          $('.select-area-content').scrollTop(0)
        })
      }
      if (typeof obj === 'object') {
        that.showArea.push(obj)
      }
    },
    showPopup () {
      this.showArea = []
      this.selectArea = []
      this.area = []
      this.getAreas(0)
      this.area_popup_show = true
    },
    handleCloseAreaWindow () {
      this.area_popup_show = false
    },
    handleSelectArea (item, bol) {
      if (bol) {
        this.area.push(item[0])
        this.area.push(item[1])
        this.showArea.push(item[0])
        this.getAreas(item[1])
        this.selectArea = item
      } else {
        this.area.push(item)
        this.getAreas(item)
        this.selectArea.push(item)
      }
    },
    pageback () {
      window.history.back()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.common-home-content {
  padding-bottom: 59px;
}
.common-home-content-pt {
  padding-top: 50px;
}
.header-right-btn {
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(172, 76, 56, 1);
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
}
.edit-content {
  padding-top: 15px;
  .edit-text {
    line-height: 43px;
    padding: 0;
    border: 0;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    box-shadow: none;
    border-bottom: 1px solid #e6e6e6;
  }
  .edit-area {
    min-height: 44px;
    padding-left: 0;
    padding-top: 11px;
    padding-bottom: 11px;
    line-height: 20px;
    border: 0;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    box-shadow: none;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
  }
  .edit-textarea {
    padding: 10px 0;
    border: 0;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    box-shadow: none;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
  }
  .edit-switch {
    line-height: 43px;
    padding: 0;
    border: 0;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: #333333;
    box-shadow: none;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
  }
  .van-icon {
    line-height: 43px;
  }
  .van-cell--required::before,
  .van-cell-group::after,
  .van-cell::after {
    display: none;
  }
  .tags-name-content {
    width: 100%;
    box-sizing: border-box;
    padding-top: 9px;
    padding-left: 135px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    position: relative;
    label {
      width: 68px;
      height: 16px;
      font-size: 16px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      color: #333333;
      line-height: 16px;
      position: absolute;
      left: 0;
      top: 14px;
    }
    .tags-ul {
      width: 100%;
      box-sizing: border-box;
      & > li {
        display: inline-block;
        box-sizing: border-box;
        margin-right: 10px;
        margin-bottom: 6px;
        padding: 0 8px;
        min-width: 42px;
        line-height: 24px;
        height: 26px;
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #666666;
        text-align: center;
        border: 1px solid #cccccc;
        border-radius: 4px;
        position: relative;
      }
      .actived {
        background-color: #ac4b38;
        border: 1px solid #ac4b38;
        color: #ffffff;
      }
      .add-icon {
        display: block;
        width: 12px;
        height: 12px;
        background: url("../../assets/images/address/add.png") no-repeat;
        background: none\9;
        filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/address/add.png',sizingMethod='scale');
        -webkit-background-size: 12px 12px;
        -moz-background-size: 12px 12px;
        background-size: 12px 12px;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
      }
    }
  }
}
.popup-window {
  width: 300px;
  box-sizing: border-box;
  padding: 26px 25px 27px 25px;
  .title {
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .tag-text {
    margin-top: 28px;
    line-height: 30px;
    padding: 0;
    border: 0;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    box-shadow: none;
    border-bottom: 1px solid #e6e6e6;
    input {
      text-align: center;
    }
  }
  .van-cell--required::before,
  .van-cell-group::after,
  .van-cell::after {
  }
  .btns {
    margin-top: 28px;
    width: 100%;
    box-sizing: border-box;
    .left {
      width: 120px;
      line-height: 30px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(172, 76, 56, 1);
      text-align: center;
      border: 1px solid rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
    .right {
      width: 120px;
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #fff;
      text-align: center;
      background-color: rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
  }
}
.delete-popup-window {
  width: 300px;
  box-sizing: border-box;
  padding: 35px 25px 27px 25px;
  .title {
    line-height: 17px;
    font-size: 17px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    text-align: center;
    color: rgba(52, 52, 52, 1);
  }
  .btns {
    margin-top: 42px;
    width: 100%;
    box-sizing: border-box;
    .left {
      width: 120px;
      line-height: 30px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(172, 76, 56, 1);
      text-align: center;
      border: 1px solid rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
    .right {
      width: 120px;
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #fff;
      text-align: center;
      background-color: rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
  }
}
.area-popup-content {
  padding-top: 44px;
  height: 60%;
  box-sizing: border-box;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.area-popup-pt {
  padding-top: 146px;
}
.area-popup-pt2 {
  padding-top: 189px;
}
.area-popup-title {
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #333333;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  .close {
    display: block;
    width: 22px;
    height: 23px;
    background: url("../../assets/images/address/close.png") no-repeat;
    background: none\9;
    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/address/close.png',sizingMethod='scale');
    -webkit-background-size: 11px 12px;
    -moz-background-size: 11px 12px;
    background-size: 11px 12px;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 5px;
  }
}
.area-steps {
  padding-left: 42px;
  padding-bottom: 15px;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 36px;
  left: 0;
  background-color: #fff;
  z-index: 1;
  .step-p {
    margin: 0;
    line-height: 44px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    text-align: left;
    position: relative;
  }
  .actived {
    color: #ffffff;
  }
  .step-p::before {
    content: "";
    display: block;
    width: 1px;
    height: 100%;
    background-color: #ac4b38;
    position: absolute;
    left: -23px;
    top: 0;
    z-index: 1;
  }
  .step-p::after {
    content: "";
    display: block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #ac4b38;
    margin: auto;
    position: absolute;
    left: -26px;
    top: 0;
    bottom: 0;
    z-index: 3;
  }
  .actived::after {
    content: "";
    display: block;
    width: 7px;
    height: 7px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1px solid #ac4b38;
    background-color: #fff;
    margin: auto;
    position: absolute;
    left: -26px;
    top: 0;
    bottom: 0;
    z-index: 3;
  }
  .first-step {
    content: "";
    display: block;
    width: 1px;
    height: 50%;
    background-color: #fff;
    position: absolute;
    left: -23px;
    top: 0;
    z-index: 2;
  }
  .last-step {
    content: "";
    display: block;
    width: 1px;
    height: 50%;
    background-color: #fff;
    position: absolute;
    left: -23px;
    bottom: 0;
    z-index: 2;
  }
  .line {
    width: 100%;
    height: 1px;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
    position: absolute;
    left: 0;
    bottom: 0;
    span {
      display: block;
      width: 100%;
      height: 100%;
      background-color: #e6e6e6;
    }
  }
}
.select-area-content {
  height: 100%;
  overflow-y: auto;
}
.pt15 {
  padding-top: 15px;
}
.pt16 {
  padding-top: 16px;
}
.select-area-title {
  padding-left: 15px;
  line-height: 14px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #999;
  text-align: left;
}
.hot-citys-ul {
  margin-top: 5px;
  margin-bottom: 12px;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
}
.hot-citys-li {
  margin-top: 15px;
  width: 20%;
  padding: 0 5px;
  box-sizing: border-box;
}
.hot-citys-name {
  width: 100%;
  line-height: 28px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}
.area-initials-ul {
  width: 100%;
  box-sizing: border-box;
}
.area-initials-li {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  line-height: 34px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #333333;
  text-align: left;
  margin-bottom: 10px;
}
.area-initials-li-pr {
  padding-left: 42px;
}
.area-initials-label {
  line-height: 34px;
  color: #999999;
  position: absolute;
  left: 15px;
  top: 0;
}
.fixed-btns {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 15px;
  position: fixed;
  left: 0;
  bottom: 0;
  & > button {
    display: block;
    width: 100%;
    box-sizing: border-box;
    line-height: 43px;
    font-size: 17px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    background: rgba(172, 76, 56, 1);
    border-radius: 4px;
  }
}
</style>
<style>
.popup-window .tag-text input {
  text-align: center;
}
.edit-text .van-icon {
  line-height: 43px;
}
.edit-area {
  padding-right: 16px !important;
  position: relative;
}
.imgStep{
  position: absolute;
  top: 170px;
  width: 8px;
  height: 10px;
  right: 20px;
  z-index: 9999;
}
/*.edit-area::after {*/
/*  content: "";*/
/*  display: block !important;*/
/*  width: 6px;*/
/*  height: 10px;*/
/*  background: url("../../assets/images/address/gengd.png") no-repeat;*/
/*  background: none\9;*/
/*  filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/address/gengd.png',sizingMethod='scale');*/
/*  -webkit-background-size: 6px 10px;*/
/*  -moz-background-size: 6px 10px;*/
/*  background-size: 6px 10px;*/
/*  margin: auto;*/
/*  position: absolute;*/
/*  top: 0;*/
/*  bottom: 0;*/
/*  right: 0;*/
/*  transform: scaleY(1);*/
/*  left: auto;*/
/*  border-bottom: 0;*/
/*}*/
.tag-popup-window {
  border-radius: 6px;
}
.van-popup {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/address/address.vue